import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Contact.css';
import SubHero from '../../components/SubHero/SubHero';
import heroImage from '../../images/hero2.jpg'
import FAQ from '../../components/FAQ/FAQ'
import emailjs from '@emailjs/browser';


const ContactPage = () => {

  const [loading, set_loading] = React.useState(false);
  const [open, set_open] = React.useState({
    state: false,
    message: '',
    type: ''
  })

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: 'Hi, I think we need Oma Media Space Limited to help us with XYZ.'
  });
    
  useEffect(() => {

    window.scrollTo(0, 0)

    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  



  async function handleSubmit (e) {
    e.preventDefault();

    if(
      formData.name.trim().length < 1 || 
      formData.subject.trim().length < 1 || 
      (formData.email.trim().length < 1 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) || 
      formData.message.trim().length < 1
      ) {
      set_open({
        state: true,
        message: 'Fill all field please and check email address',
        type: 'error'
      })
      return false;
    }

    set_loading(true)
    await emailjs.send("service_xsegkba", "template_yl2201g", formData, '3GO8wURft1C0v-HdZ')
      .then((result) => {
          set_open({
            state: true,
            message: "Your message has been sent successfully 🎉. We'll get back to you shortly.",
            type: 'success'
          });
          set_loading(false);

          setFormData ({
            name: "",
            email: "",
            message: "Hi, I think we need Oma Media Space Limited to help us with XYZ.",
            phone: "",
            subject: "",
          })

      }, (error) => {
          set_loading(false);
      });

  }




  return (
    <div className="Contact">
      {/* Hero Section */}
      <SubHero 
        title="Get in touch"
        subtitle="We'd love to hear from you!"
        image={heroImage}
      />


      <div className='BODY'>
        {/* Contact Info Section */}
        <div className="Contact-info">
          <div className="Contact-container">
            <div className="Contact-info-grid">
              <div className="Contact-info-card" data-aos="fade-up" data-aos-delay="100">
                <div className="Contact-info-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="goldenrod" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <h3 className="Contact-info-title">Our Location</h3>
                <p className="Contact-info-text">
                  Lagos<br />
                  Nigeria
                </p>
              </div>
              
              <div className="Contact-info-card" data-aos="fade-up" data-aos-delay="200">
                <div className="Contact-info-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="goldenrod" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <h3 className="Contact-info-title">Call Us</h3>
                <p className="Contact-info-text">
                +234 814 2986 019<br />
                  Mon - Sun, 24 hours
                </p>
              </div>
              
              <div className="Contact-info-card" data-aos="fade-up" data-aos-delay="300">
                <div className="Contact-info-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="goldenrod" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <h3 className="Contact-info-title">Email Us</h3>
                <p className="Contact-info-text">
                  omamediaspace@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="Contact-form-section">
          <div className="Contact-container">
            <div className="Contact-form-container" data-aos="fade-up">
              <div className="Contact-form-header">

                {
                  !open.state &&
                  <aside>
                    <h2 className="Contact-section-title header-1">Send Us a Message</h2>
                    <p className="Contact-form-subtitle">
                      Have a question or want to work together? Fill out the form below and we'll get back to you shortly.
                    </p>
                  </aside>
                }
              </div>
              
              {
                open.state ? (
                <div className="Contact-success-message">
                  <svg className="Contact-success-icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <h3 className="Contact-success-title header-3">Thank You!</h3>
                  <p className="Contact-success-text text-1"> {open.message} </p>
                </div>
              ) : (
                <form className="Contact-form" onSubmit={handleSubmit}>
                  <div className="Contact-form-grid">
                    <div className="Contact-form-group">
                      <label htmlFor="name" className="Contact-form-label text-1">Your Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="Contact-form-input"
                        required
                      />
                    </div>
                    
                    <div className="Contact-form-group">
                      <label htmlFor="email" className="Contact-form-label text-1">Your Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="Contact-form-input"
                        required
                      />
                    </div>
                    
                    <div className="Contact-form-group">
                      <label htmlFor="phone" className="Contact-form-label text-1">Phone Number</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="Contact-form-input"
                      />
                    </div>
                    
                    <div className="Contact-form-group">
                      <label htmlFor="subject" className="Contact-form-label text-1">Subject *</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="Contact-form-input"
                        required
                      />
                    </div>
                    
                    <div className="Contact-form-group Contact-full-width">
                      <label htmlFor="message" className="Contact-form-label text-1">Your Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="Contact-form-textarea"
                        rows="6"
                        required
                      ></textarea>
                    </div>
                    
                    <div className="Contact-form-group Contact-full-width text-1">
                      <button type="submit" className="Contact-form-button">
                        {
                          loading ?
                          'Sending...':
                          <> Send Message <span className="Contact-btn-arrow">→</span> </>
                        }
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>





        {/* Map Section */}
        <div className="Contact-map" data-aos="fade-up">
          <div className="Contact-map-container">
            {/* This would normally be a Google Maps iframe, but we're using a placeholder image */}
            <div className="Contact-map-placeholder">

              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253682.46310770285!2d3.119142842927999!3d6.548369370928848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8b2ae68280c1%3A0xdc9e87a367c3d9cb!2sLagos!5e0!3m2!1sen!2sng!4v1744327151547!5m2!1sen!2sng"
                width="100%" 
                height="450" 
                allowFullScreen="" 
                loading="lazy" 
                title="Responsive Google Maps"
                referrerPolicy="no-referrer-when-downgrade">

              </iframe>
            
            </div>
          </div>
        </div>


        {/* FAQ Section */}
        <FAQ />

      </div>
    </div>
  );
};

export default ContactPage;